import { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Eyebrow + uppercase Space Grotesk title used across all Stitch pages.
 *
 * Example:  <StitchHeading eyebrow="PROFILE" title="Your Identity" />
 */
export const StitchHeading = ({
  eyebrow,
  title,
  subtitle,
  className,
  align = "left",
}: {
  eyebrow: string;
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
  align?: "left" | "center";
}) => (
  <div className={cn(align === "center" && "text-center", className)}>
    <span className="font-display text-[10px] font-semibold uppercase tracking-[0.3em] text-primary/80">
      — {eyebrow}
    </span>
    <h1 className="font-display mt-2 text-2xl font-bold uppercase leading-tight tracking-tight text-foreground md:text-3xl">
      {title}
    </h1>
    {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
  </div>
);
